import { render, staticRenderFns } from "./MachineItem.vue?vue&type=template&id=510e81e9&lang=pug&"
import script from "./MachineItem.vue?vue&type=script&lang=js&"
export * from "./MachineItem.vue?vue&type=script&lang=js&"
import style0 from "./MachineItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports